const footer = {
  footer: {
    imageTitle: 'Besuchen Sie die Enphase Energy Website',
    privacy: 'Datenschutz',
    terms: 'AGB',
    enphaseText: '©2008-%{currentYear} Enphase Energy Inc. Alle Rechte vorbehalten.',
    language: 'Sprache',
    production_ct: {
      verify_ct: "CT Überprüfen",
      checlist_nodata: "Unzureichende Zählerdaten zur Durchführung dieser Prüfung verfügbar",
      production_meter_verification: "Erzeugungszähler-Verifikation",
      serial_no: "Seriennummer",
      polarity_check: "Polaritätsprüfung",
      polarity_check_failed: "Polaritätsprüfung fehlgeschlagen",
      ct_missing_branch_check: "Prüfung auf fehlende Zweigstromkreise im CT",
      polarity_check_passed: "Polaritätsprüfung bestanden",
      ct_no_missing_branch_circuit: "CT hat keine fehlenden Zweigstromkreise",
      incorrect_direction_or_phase_message: "Produktions-CT-Richtung oder Phase könnte falsch sein",
      hide_details: "Details ausblenden",
      check_try_again: "Überprüfen Sie Folgendes und versuchen Sie es erneut",
      pv_on_for_5_min: "Vergewissern Sie sich, dass der PV-Stromkreis eingeschaltet ist und seit mindestens 5 Minuten eingeschaltet war",
      l1_wires_production_ct_message: "Prüfen Sie, ob nur L1-Drähte durch den Produktions-CT laufen und der Produktionsfluss in Richtung des CT-Pfeils von PV zum Leistungsschalter verläuft",
      blue_white_wires_position_message: "Stellen Sie sicher, dass die blauen und weißen Kabel korrekt an den Klemmenblock des Gateway angeschlossen sind",
      wires_include_pv_generation_not_load_storage: "Stellen Sie sicher, dass die Kabel, die durch das Produktions-CT führen, nur die PV-Erzeugung enthalten (keine Lasten oder Speicher)",
      l1_a_correct_phase_message: "Stellen Sie sicher, dass die korrekte Phase, d.h. L1(a), durch das Produktions-CT geht",
      l1_phase_consistency_check_message: "Überprüfen Sie die L1-Phasenkonsistenz mit einem Digitalmessgerät und stellen Sie sicher, dass L1 der PV-Stromkreise und L1 am Gateway in derselben Phase sind",
      missing_branch_warning: "Produktions-CT könnte fehlende Zweigstromkreise haben",
      test_only_valid_for_sunshine_hours: "Dieser Test ist nur während der Sonnenstunden gültig",
      reading_lower_than_expected: "Produktionsmesswerte liegen unter den Erwartungen. Überprüfen Sie Folgendes, und tippen Sie dann erneut, um es erneut zu versuchen",
      wires_include_all_pv_generation: "Stellen Sie sicher, dass das Kabel, das durch das Produktions-CT führt, alle PV-Generationsstromkreise einschließt",
      branch_circuit_reverse_check: "Stellen Sie sicher, dass keiner der Zweigstromkreise in umgekehrter Richtung durch das CT geht",
      storage_load_circuits_through_production_ct: "Stellen Sie sicher, dass Speicher- oder Laststromkreise durch das Produktions-CT gehen",
      show_details: "Details anzeigen",
      verify_ct_not_supported_for_device: "CT überprüfen wird von diesem Gerät nicht unterstützt",
      verify_ct_timeStamp: "Geprüft am",
      verify_ct_systemID: "System-ID",
      prodct_reversepolarity_text: "Produktions-CT-Richtung oder Phase könnte falsch sein",
      prodct_reverse_polarity_btn: "Umgekehrte Polarität",
      verify_ct_timeout: "Anfrage wurde unterbrochen. Bitte versuchen Sie es erneut."

    }
  }
};

export default footer;
